<template>
    <main id="content-main" class="section content-main">
        <article>
            <h1>Links</h1>
            <ul>
                <li>Musicisti europei a Venezia, Roma e Napoli (1650–1750): <a href="http://www.musici.eu" target="_blank">http://www.musici.eu</a></li>
                <li>Music Migrations in the Early Modern Age: the Meeting of the East, West and South: <a href="http://www.musmig.eu/home/" target="_blank">http://www.musmig.eu/home/</a></li>
                <li>A Cosmopolitan Composer in Pre-Revolutionary Europe – Giuseppe Sarti: <a href="http://sarti-edition.de/" target="_blank">http://sarti-edition.de/</a></li>
                <li>Die Opera buffa als europäisches Phänomen. Migration, Mapping und Transformation einer neuen Gattung: <a href="http://www.prof-musikwissenschaft.uni-bayreuth.de/de/research/Projekte/index.html" target="_blank">http://www.prof-musikwissenschaft.uni-bayreuth.de/de/research/Projekte/index.html</a></li>
                <li>Die ‚Operisti’ als kulturelles Netzwerk: Einblicke und Kontexte der Pirker-Korrespondenz: <a href="http://www.operistinetwork.sbg.ac.at" target="_blank">http://www.operistinetwork.sbg.ac.at</a></li>
                <li>Pietro Metastasio. Drammi per musica: <a href="http://www.progettometastasio.it" target="_blank">http://www.progettometastasio.it</a></li>
                <li>Varianti all’opera. Goldoni, Jommelli, Metastasio e Pergolesi sulla scena musicale europea: <a href="http://www.variantiallopera.it" target="_blank">http://www.variantiallopera.it</a></li>
                <li>Georg-Friedrich-Händel-Gesellschaft/Hallische Händel-Ausgabe: <a href="http://haendel.de/HallischeHaendelAusgabe" target="_blank">http://haendel.de/HallischeHaendelAusgabe</a></li>
                <li>Polish Academy of Sciences: <a href="http://www.ispan.pl/en/about-the-institute-of-art-history-of-the-polish-academy-of-sciences" target="_blank">http://www.ispan.pl/en/about-the-institute-of-art-history-of-the-polish-academy-of-sciences</a> and <a href="http://www.ispan.pl/en/research-activities/department-of-musicology" target="_blank">http://www.ispan.pl/en/research-activities/department-of-musicology</a></li>
                <li>Zentrum Musik – Edition – Medien (ZenMEM): <a href="https://zenmem.de" target="_blank">https://zenmem.de</a></li>
            </ul>
        </article>
    </main>
</template>

<script>

    export default {
        name: 'links'
    }
</script>

<style scoped lang="css">
    @import "../styles/content.css";
</style>
